import type { WorkspaceRole } from '@/lib/workspace/types/types'

/**
 * `true` when the role can manage the workspace: edit settings, change member
 * roles, remove members, invite new members. `member` cannot.
 */
export function canManageWorkspace(role: WorkspaceRole): boolean {
  return role === 'owner' || role === 'admin'
}

/**
 * `true` only for owners — the only role that can delete the workspace.
 */
export function canDeleteWorkspace(role: WorkspaceRole): boolean {
  return role === 'owner'
}
